import React from 'react';
import SelectComponent from 'react-select';

interface IMultiSelectProps {
  name: any;
  label?: any;
  values?: any;
  errors?: any;
  touches?: any;
  onChange?: any;
  onBlur?: any;
  onFocus?: any;
  placeholder?: any;
  loading?: any;
  options?: any;
  getOptionValue?: any;
  getOptionLabel?: any;
  disabled?: any;
}

export const MultiSelect: React.FC<IMultiSelectProps> = ({
  name,
  label,
  values,
  errors,
  touches,
  onChange,
  onBlur,
  onFocus,
  placeholder,
  loading,
  options,
  getOptionValue,
  getOptionLabel,
  disabled,
}) => {
  return (
    <div className='flex flex-col gap-1'>
      <label className={`text-[11px] font-bold text-Black`}>{label}</label>
      <SelectComponent
        isClearable
        isSearchable
        isMulti
        onBlur={onBlur}
        onFocus={onFocus}
        onChange={onChange}
        placeholder={placeholder}
        options={options}
        isLoading={loading}
        isDisabled={disabled}
        name={name}
        getOptionLabel={(option) => option[getOptionLabel]}
        getOptionValue={(option) => option[getOptionValue]}
        defaultValue={values[name]}
        theme={(theme) => ({
          ...theme,
          borderRadius: 5,

          colors: {
            ...theme.colors,

            text: '#0F1A2D',
            primary25: '#E5E7EB',
            primary50: '#E5E7EB',

            primary: '#111B30',
          },
        })}
        className={`text-xs border rounded-md`}
        styles={{
          control: () => ({
            display: 'flex',
            backgroundColor: '#fff',
            borderRadius: '4px',
          }),
        }}
      />
    </div>
  );
};
